import Button from './Button';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export default function ErrorState({
  message = 'Ocurrió un error al cargar la información.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-red-200 bg-red-50 px-6 py-12 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
        <i className="ri-error-warning-line text-2xl"></i>
      </span>
      <div>
        <h3 className="font-heading text-base font-semibold text-red-800">
          No se pudo cargar la información
        </h3>
        <p className="mx-auto mt-1 max-w-md text-sm text-red-700">{message}</p>
      </div>
      {onRetry && (
        <Button variant="outline" icon="ri-refresh-line" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </div>
  );
}